import Axios from 'axios'
import config from 'config/env_config'

export const getUserData = async () => {
  try {
    const email = window.localStorage.getItem('email')
    const { data } = await Axios.get(`users/?email=${email}`)
    return data[0]
  } catch (error) {
    return error
  }
}

export const editUserData = async (userData, authorization) => {
  try {
    const payload = {
      birthDate: userData.birthDate,
      homePhone: userData.phone,
      firstName: userData.firstName,
      lastName: userData.lastName,
      document: userData.document,
      isMktsrvTermsAccepted: userData.isMktsrvTermsAccepted,
      isNewsletterOptIn: userData.isNewsletterOptIn
    }
    const { data } = await Axios({
      baseURL: config.user,
      url: '/users',
      method: 'patch',
      withCredentials: true,
      data: payload,
      headers: {
        authorization
      }
    })
    return data
  } catch (error) {
    return error
  }
}

export const me = async (updateIntegration = false) => {
  const { data } = await Axios({
    baseURL: config.user,
    url: '/users/me',
    method: 'get',
    withCredentials: true,
    headers: {
      'cache-control': 'no-cache',
      'update-integration': updateIntegration
    }
  })

  window.localStorage.setItem('userId', data.userId)
  window.localStorage.setItem('vtexUserId', data.id)
  window.localStorage.setItem('email', data.email)
  window.localStorage.setItem('firstName', data.firstName)
  window.localStorage.setItem('lastName', data.lastName)
  window.localStorage.setItem('userPhone', (data.homePhone || data.phone))
  window.localStorage.setItem('userBirthDate', data.birthDate)
  window.localStorage.setItem('thermAccepted', data.thermAccepted)

  return data
}

export const getUserAddresses = async () => {
  const { data } = await Axios({
    baseURL: config.user,
    url: '/users/addresses',
    method: 'get',
    withCredentials: true,
    headers: {
      'cache-control': 'no-cache'
    }
  })

  window.localStorage.setItem('userAddresses', JSON.stringify(data))

  return data
}

export const getUserAddress = async (vtexId) => {
  const { data } = await Axios({
    baseURL: config.user,
    url: `/customers/${vtexId}`,
    method: 'get',
    withCredentials: true,
    headers: {
      'cache-control': 'no-cache'
    }
  })
  return data
}

export const getUserCep = async (cep) => {
  try {
    const { data } = await Axios({
      baseURL: config.urlBase,
      url: `freight/cep/${cep}`,
      method: 'get',
      withCredentials: true
    })
    return data
  } catch (error) {
    return error.response
  }
}
